module.exports = __webpack_public_path__ + "img/icon-success.40f3da63.svg";